import { FC } from 'react';

import { BadgeBlockContentProps } from './model';
import { BadgeBlockContainer } from './ProductVariationBadges.styles';

export const BadgeBlock: FC<BadgeBlockContentProps> = ({ children, ariaLabelledBy }) => {
    return children ? <BadgeBlockContainer aria-labelledby={ariaLabelledBy}>{children}</BadgeBlockContainer> : null;
};
